import { createReducer, on } from '@ngrx/store';
import { AuditLogEntry } from 'src/app/types/patient-audit.types';
import * as authActions from '../auth/auth.actions';
import * as patientAuditActions from '../patient-audit/patient-audit.actions';
import * as patientActions from '../patient/patient.actions';
import { PatientAuditFilters, PatientAuditQuery, PatientAuditQueryType } from './patient-audit.actions';

export interface State {
	loadedOnce: boolean;
	loading: boolean;
	query: PatientAuditQuery;
	filters: PatientAuditFilters;
	sortAscending: boolean;
	displayCount: number;
	auditLog: AuditLogEntry[];
}

export const initialState: State = {
	loadedOnce: false,
	loading: true,
	query: {
		queryType: PatientAuditQueryType.Patient,
		visitId: '',
		maxResults: 1000
	},
	filters: {
		fromDate: '',
		toDate: '',
		userId: null
	},
	sortAscending: false,
	displayCount: 50,
	auditLog: []
}

export const patientAuditReducer = createReducer(
	initialState,
	on(patientAuditActions.queryAndFiltersInitialised, (state, { query }) => ({
		...state,
		query: {
			...initialState.query,
			...query
		},
		filters: { ...initialState.filters }
	})),
	on(patientAuditActions.queryChanged, (state, { query }) => ({
		...state,
		loadedOnce: true,
		loading: true,
		displayCount: initialState.displayCount,
		query: {
			...state.query,
			...query
		}
	})),
	on(patientAuditActions.filtersChanged, (state, { filters }) => ({
		...state,
		displayCount: initialState.displayCount,
		filters: {
			...state.filters,
			...filters
		}
	})),
	on(patientAuditActions.auditLogChanged, (state, { auditLog }) => ({
		...state,
		loading: false,
		auditLog: auditLog
	})),
	on(patientAuditActions.sortDirectionChanged, (state) => ({
		...state,
		displayCount: initialState.displayCount,
		sortAscending: !state.sortAscending
	})),
	on(patientAuditActions.displayCountChanged, (state) => ({
		...state,
		displayCount: state.displayCount + initialState.displayCount
	})),
	on(patientActions.patientDeselected, () => initialState),
	on(authActions.clearStateRequested, () => initialState)
);